import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Features } from "@/components/landing/Features";
import { AppStoreSection } from "@/components/landing/AppStoreSection";
import { Support } from "@/components/landing/Legal";
import { Footer } from "@/components/landing/Footer";

function App() {
  return (
    <div id="top" className="min-h-screen bg-white text-slate-800 antialiased">
      <Header />
      <main>
        <Hero />
        <Features />
        <AppStoreSection />
        <Support />
      </main>
      <Footer />
    </div>
  );
}

export default App;
